<template><div><h1 id="personenfilter-kopf" tabindex="-1"><a class="header-anchor" href="#personenfilter-kopf"><span>Personenfilter Kopf</span></a></h1>
<p>Filter Personen — Filterkopf, Definiert Personenfilter</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In der Ansicht Personen können Filter für sehr verschiedene Zwecke eingesetzt werden, wobei die</p>
<ul>
<li>
<p>manuelle Bearbeitung spezieller Personen</p>
</li>
<li>
<p>Bildung von zielgruppenspezifischen Selektionen für Database-Marketing</p>
</li>
<li>
<p>Auswertung bestimmter zielgruppenspezifischer Daten</p>
</li>
</ul>
<p>im Vordergrund stehen.</p>
<p>Der Filter besteht aus einem Kopf, in dem gewisse Informationen genereller Art definiert werden, sowie einzelnen <RouteLink to="/referenz/refs/ft.refdata.adrfilterpos.html" title="Filterpositionen (Personen)">Filterpositionen</RouteLink> , deren Kombination die Selektion der Personen bestimmt.</p>
<p>Der Filterkopf umfasst im wesentlichen folgende Informationen:</p>
<ul>
<li>
<p>Eigen- oder Fremdadresse</p>
</li>
<li>
<p>Berücksichtigung Personenbeziehungen</p>
</li>
<li>
<p>Berücksichtigung vorheriger Selektionen bzw. Verkettung von Filtern</p>
</li>
<li>
<p>Laufzeitentscheide des Benutzers.</p>
</li>
</ul>
<p>Der Filter kann sich in 2 unterschiedlichen Stati befinden: markiert/nicht markiert. Jeder Filter kann markiert werden (muss aber nicht). Je nachdem, ob der Filter markiert ist oder nicht, reagiert das System anders.</p>
<ul>
<li>
<p>An vielen Stellen wird die Markierung nicht berücksichtigt, da das System davon ausgeht, dass der Benutzer eine jeweils aktuelle Interpretation des Dateninhalts haben möchte. Dies ist z.B. in der Zusagenfakturierung der Fall.</p>
</li>
<li>
<p>Bei der Verwendung eines Filters zur Ereignisverknüpfung oder beim Export von Personen nimmt das System dagegen an, dass ein bestimmter Datenzustand &quot;eingefroren&quot; übernommen werden soll. Es reagiert deshalb wie folgt: Exportiert werden können nur markierte Filter. Wird eine Ereignisverknüpfung definiert, übernimmt das System die bestehende Markierung bzw. führt - wenn keine Markierung vorhanden ist - zuerst eine Markierung durch.</p>
</li>
</ul>
<p>Beide Stati werden auch in Filterketten berücksichtigt.</p>
<p>Es gibt 3 Filtertypen:</p>
<dl>
<dt>Adressen</dt>
<dd>Er selektiert Personen aus dem eigenen Adressstamm (Eigenadressen) aufgrund bestimmter Filterbedingungen. Dies ist der weitaus am häufigsten verwendete Filtertyp.</dd>
<dt>Fremdadressen</dt>
<dd>Er selektiert Personen aus dem Fremdadressstamm. Dazu stehen separate Filterpositionen zur Verfügung.</dd>
<dt>Zusammenführung</dt>
<dd>Er führt Personen, welche in mehreren Personen- und/oder Fremdadressfilter markiert wurden zusammen. Der Zusammenführfilter ist die einzige Möglichkeit, die eigenen und die Fremdadressen im Filter zu mischen. Adressen können hier nicht ausgeschlossen werden. Der Zusammenführfilter wird vor allem in der Produktion von Mailings eingesetzt. Im Detail siehe <a class="link" href="../../manual/customer/selektionen-mailings.html" title="7. Mailings (Segmentierung)">Selektionen, Mailings </a>.</dd>
</dl>
<p>Pfad: <code v-pre>Personen → Filter</code></p>
<h2 id="datenfelder-im-anzeige-modus" tabindex="-1"><a class="header-anchor" href="#datenfelder-im-anzeige-modus"><span>Datenfelder im Anzeige-Modus</span></a></h2>
<dl>
<dt>Filter</dt>
<dd>Filterbezeichnung zur Identifikation des Filters im System, alphanumerisches Feld.</dd>
<dt>Status</dt>
<dd>markiert = Personen haben eine Markierung mit diesem Filter<br>nicht markiert = Personen sind nicht markiert mit diesem Filter</dd>
<dt>Filtertyp</dt>
<dd>Die folgenden Filtertypen sind möglich:
<table>
<thead>
<tr>
<th>Typ</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Adressen</td>
<td>Personen, eigene Datenbank</td>
</tr>
<tr>
<td>Fremdadressen</td>
<td>Personen, Fremdadressdatenbank</td>
</tr>
<tr>
<td>Zusammenführung</td>
<td>Zusammenführung einzelner Filter, auch Mischung von Personen und Fremdadressen möglich</td>
</tr>
</tbody>
</table>
</dd>
<dt>Fremddatenbank</dt>
<dd>Fremddatenbank, nur bei Fremdadressen, auswahl der Fremddatenbank</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung des Filters, freies Textfeld</dd>
<dt>A</dt>
<dd>Ein Icon in Form einer Büroklammer zeigt an, dass zu diesem Filter mindestens 1 Attachment verknüpft ist.</dd>
<dt>Anzahl markiert</dt>
<dd>Anzahl markierte Personen im Filter</dd>
<dt>markiert am</dt>
<dd>Datum der Markierung</dd>
<dt>Info</dt>
<dd>In diesem Feld werden die Eingabeparameter für den Filter angezeigt.</dd>
<dt>Verwendung</dt>
<dd>Das Feld zeigt an, wo der Filter sonst noch verwendet wird.</dd>
<dt>Referenzwerte</dt>
<dd>In diesem Feld können Referenzwerte wie z.B. Tagesdatum oder sonstige Werte definiert werden, die in den Filterpositionen verwendet werden können. Damit können Filter sehr leicht angepasst werden, in dem lediglich die Referenzwerte (die in der Regel dynamisch sind) angepasst werden, statt jede betroffene Position anzupassen.</dd>
<dt>Berechtigung für</dt>
<dd>In diesem Feld kann die Schreibberechtigung definiert werden. Nebst den globalen Berechtingungen in der Benutzerverwaltung, können hier bestimmte Benutzer definiert werden. Standardmässig haben alle Benutzer die in der Benutzerverwaltung für die Bearbeitung von Filtern berechtigt sind Zugriff.</dd>
</dl>
<h2 id="datenfelder-im-editier-modus" tabindex="-1"><a class="header-anchor" href="#datenfelder-im-editier-modus"><span>Datenfelder im Editier-Modus</span></a></h2>
<dl>
<dt>Filter</dt>
<dd>Filterbezeichnung zur Identifikation des Filters im System, alphanumerisches Feld.</dd>
<dt>Status</dt>
<dd>markiert = Personen haben eine Markierung mit diesem Filter<br>nicht markiert = Personen sind nicht markiert mit diesem Filter</dd>
<dt>Filtertyp</dt>
<dd>Die folgenden Filtertypen sind möglich:| Typ | Bedeutung |
| --- | --- |
| Adressen | Personen, eigene Datenbank |
| Fremdadressen | Personen, Fremdadressdatenbank |
| Zusammenführung | Zusammenführung einzelner Filter, auch Mischung von Personen und Fremdadressen möglich |</dd>
<dt>Fremddatenbank</dt>
<dd>Fremddatenbank, nur bei Fremdadressen, auswahl der Fremddatenbank</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung des Filters, freies Textfeld</dd>
<dt>Anzahl markiert</dt>
<dd>Anzahl markierte Personen im Filter</dd>
<dt>markiert am</dt>
<dd>Datum der Markierung</dd>
<dt>ohne Label</dt>
<dd>nur Personen ohne Personensperre = Gesperrte Personen werden nicht geprüft, resp. selektiert<br>alle Personen (auch gesperrte) = Alle Personen werden geprüft, Sperren werden ignoriert.</dd>
<dt>mit Adresse im Kanal</dt>
<dd>Bei Auswahl eines Kanals muss die Person über eine aktive Adresse mit ausgewähltem Kanal verfügen. Falls der Kanal nicht relevant ist, dann die Auswahl &quot;ohne Einschränkung&quot; wählen.</dd>
<dt>bei Kanal-/Adresssperre</dt>
<dd>trotzdem wählen = die Person wird trotz Kanal-/Adresssperre geprüft, resp. selektiert<br>nicht wählen = die Person wird wenn entsprechende Kanal-/Adresssperre vorhanden ist, nicht geprüft, resp. nicht selektiert</dd>
<dt>maximal Anzahl prüfen</dt>
<dd>Maximal die eingegebene Anzahl Personen werden geprüft, auch wenn noch weitere Personen den Filterkriterien entsprechen würden. Verwendung z.B. zum testen vom Filter, da für das Markieren nicht alle Personen durchlaufen werden (Zeitersparniss).</dd>
<dt>maximal Anzahl Personen markieren</dt>
<dd>Der Filter markiert maximal die eingegebene Anzahl Personen, resp. beendet die Markierung sobald die eingegebene Anzahl erreicht ist.</dd>
<dt>Selektion bei Personenbeziehungen</dt>
<dd>Auswahl &quot;jede Person&quot;, markiert unabhängig von Personenbeziehungen jede Person die den Filterbedingungen entspricht.<br>Auswahl &quot;einmal pro Haushalt&quot;, bei Personen mit Haushaltsbeziehung wird nur eine Person markiert.</dd>
<dt>Botenroutierung</dt>
<dd>Code der <a class="link" href="ft.refdata.tblbotcode.html" title="Botenroutierungen">Botenroutierung</a>, auswahl aus Tabelle.</dd>
<dt>Referenzwerte</dt>
<dd>In diesem Feld können Referenzwerte wie z.B. Tagesdatum oder sonstige Werte definiert werden, die in den Filterpositionen verwendet werden können. Damit können Filter sehr leicht angepasst werden, in dem lediglich die Referenzwerte (die in der Regel dynamisch sind) angepasst werden, statt jede betroffene Position anzupassen.</dd>
<dt>Berechtigung für</dt>
<dd>In diesem Feld kann die Schreibberechtigung definiert werden. Nebst den globalen Berechtingungen in der Benutzerverwaltung, können hier bestimmte Benutzer definiert werden. Standardmässig haben alle Benutzer die in der Benutzerverwaltung für die Bearbeitung von Filtern berechtigt sind Zugriff.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="markieren" tabindex="-1"><a class="header-anchor" href="#markieren"><span>Markieren...</span></a></h3>
<p>Markieren des Filters. Die Filterbedingungen werden geprüft und jede Person, welche den Bedingungen entspricht, wird markiert. Siehe <RouteLink to="/referenz/refs/ft.refproc.filtermark.html" title="Filter markieren">Filter markieren</RouteLink></p>
<h3 id="markierung-aufheben" tabindex="-1"><a class="header-anchor" href="#markierung-aufheben"><span>Markierung aufheben...</span></a></h3>
<p>Die Markierung der enthaltenen Personen im Filter werden aufgehoben.</p>
<h3 id="adresslisten-und-etiketten-drucken" tabindex="-1"><a class="header-anchor" href="#adresslisten-und-etiketten-drucken"><span>Adresslisten und Etiketten drucken...</span></a></h3>
<p>Druckt die enthaltenen Personen im Filter als Adresslisten oder Adressetiketten aus.</p>
<h3 id="etiketten-endlosdrucker" tabindex="-1"><a class="header-anchor" href="#etiketten-endlosdrucker"><span>Etiketten Endlosdrucker...</span></a></h3>
<p>Druckt die enthaltenen Personen im Filter als Etiketten für Endlosdrucker aus.</p>
<h3 id="adress-export" tabindex="-1"><a class="header-anchor" href="#adress-export"><span>Adress-Export...</span></a></h3>
<p>Exportiert die Personen.</p>
<h3 id="adressen-mit-do-exportieren" tabindex="-1"><a class="header-anchor" href="#adressen-mit-do-exportieren"><span>Adressen mit DO exportieren...</span></a></h3>
<p>Exportiert die Personen mit Document Output.</p>
<h3 id="drucken" tabindex="-1"><a class="header-anchor" href="#drucken"><span>Drucken...</span></a></h3>
<p>Druckt die Filterdefinition aus.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.adrfilterpos.html" title="Filterpositionen (Personen)">Adressfilterpositionen</RouteLink> , <RouteLink to="/referenz/refs/ft.refproc.adrfiltverk.html" title="Filter verknüpfen">Filter verknüpfen</RouteLink> , <RouteLink to="/referenz/refs/ft.refproc.adrmarkauf.html" title="Filtermarkierung aufheben">Adressmarkierungen aufheben</RouteLink> , <RouteLink to="/manual/administration/botenroutierung.html" title="6. Botenroutierung">Botenroutierung, Beschreibung</RouteLink></p>
</div></template>


